import { FALLBACK_LANGUAGE, LANGUAGE_IDS, type LanguageId } from './types'

/**
 * 브라우저가 말하는 선호 언어를 지원 목록과 맞춘다.
 *
 * 결과를 저장하지 않는다. 저장하면 다음 방문에 협상 결과가 사용자 선택인 척 서버로 올라간다.
 * 이 값은 고른 적 없는 사람에게 첫 화면을 그릴 근거일 뿐이다.
 *
 * 지역을 뗀 앞마디로 맞춘다. ko-KR과 ko가 같은 언어이고 우리가 여는 것은 언어 단위다.
 *
 * 앞에서부터 훑어 우리가 여는 언어 가운데 처음 만나는 것을 쓴다. 브라우저가 말하는 순서가 곧
 * 그 사람의 우선순위다. 하나도 걸리지 않으면 영어로 그린다.
 */
export function negotiateLanguage(preferred: readonly string[]): LanguageId {
  for (const tag of preferred) {
    const base = tag.toLowerCase().split('-')[0]
    const matched = LANGUAGE_IDS.find((id) => id === base)
    if (matched) return matched
  }
  return FALLBACK_LANGUAGE
}
